import {  Button, ButtonGroup } from "@mui/material";
import { useState } from "react";
import DatatableComponent from "helpers/DatatableComponent";
import { useHistory } from "react-router-dom";
import StatusLayout from "components/Status";
import moment from "moment";

const MyAssignmentListComponent = (props) => {
  const {
    GetAllMeetings,
    location,
    notification,
    MarkAsRead,
  } = props;
  const [selected, setSelected] = useState(location?.state?.status ?? "All");
const [list,setList]=useState([])
let history = useHistory();
const columns = [
  {
    label: "Name",
    name: "name",
    options: {
      filter: true,
      sort: true,
    },
  },
  {
    label: "Start Date",
    name: "startDate",
    options: {
      filter: true,
      sort: true,
      customBodyRender: (v) => moment(v).format("DD/MM/yyyy")
    },
  },
  {
    label: "End Date",
    name: "endDate",
    options: {
      filter: true,
      sort: true,
      customBodyRender: (v) => moment(v).format("DD/MM/yyyy")
    },
  },
  {
    label: "Report To",
    name: "report.names",
    options: {
      filter: true,
      sort: true,
    },
  },

  {
    label: "Status",
    name: "status",
    options: {
      filter: true,
      sort: true,
      customBodyRender: (status) =>(<StatusLayout status={status}/>)
    },
  },
  {
    name: "id",
    label: "Action",
    options: {
      filter: true,
      sort: false,
      customBodyRender: (id) => {
        let detail =
          notification?.filter((notif) => notif?.content?.id === id && notif?.content?.type === "meetingAction") ??
          [];
        return (
          <Button
            onClick={() => {
              if (detail && detail[0]?.id) {
                MarkAsRead(detail[0]?.id);
              }
              history.push(`/admin/action/details/${id}`); 
            }}>
            <i className="fa fa-info-circle fa-md me-1" /> Details{" "}
            {detail[0]?.content?.id === id ? (
              <span className="badge bg-green-400 rounded-pill ">
                {"NEW"}
              </span>
            ) : null}
          </Button>
        );
      },
    },
  },
];


  return (
    <div className="">
          <DatatableComponent
        title={
          <ButtonGroup
            variant="outlined"
            color={"success"}
            size={"small"}
            aria-label="outlined button group">
            {["all", "not yet started", "in progress", "on hold","completed","overdue"].map((title, key) => (
              <Button
                key={key}
                type="button"
                style={{
                  backgroundColor:
                    selected === title ? "green" : "",
                  color:
                    selected === title
                      ? "white"
                      : "green",
                }}
                onClick={() => {
                  setSelected(title);
                  GetAllMeetings(title);
                }}>
                {title}
              </Button>
            ))}
          </ButtonGroup>
        }
        processData={(data) => {
          setList(data.data);
          return data;
        }}
        columns={columns}
        url={`/api/meeting-action/my-assigned/datatable/?status=${selected}`}
        useMeetingUrl={true}
        onAddNew={()=>{history.push("/admin/action/new")}}
        onRowClick={(data, { rowIndex }) => {
          let detail =
          notification?.filter((notif) => notif?.content?.id === list[rowIndex].id && notif?.content?.type === "meetingAction") ??
          [];
          if (detail && detail[0]?.id) {
            MarkAsRead(detail[0]?.id);
          }
          history.push(`/admin/action/details/${list[rowIndex].id}`); 
        }}
   
      />
     
    </div>
  );
};
export default MyAssignmentListComponent;
